import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table12bData = { [key: string]: ITable12bRow };

export interface ITable12bProps {
  data: Table12bData;
}

interface ITable12bState {
}

interface ITable12bRow {
  driversTotal: number;
  driversFatal: number;
  driversInjuryA: number;
  driversInjuryB: number;
  driversInjuryC: number;
  pedestriansTotal: number;
  pedestriansFatal: number;
  pedestriansInjuryA: number;
  pedestriansInjuryB: number;
  pedestriansInjuryC: number;
}

const sortOrder = [
  "Amphetamine",
  "Cocaine",
  "Marijuana",
  "Opiate",
  "Other Controlled Substance",
  "PCP",
  "Other Drug (excludes post-crash drugs)",
  "Not Applicable",
  "Unknown",
  "Not Stated",
  "TOTAL DRUG INVOLVEMENT",
];

export default class Table12b extends React.Component<ITable12bProps, ITable12bState> {
  constructor(props: ITable12bProps) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <>
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 21 }} />
              <col style={{ width: 579 }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={3} colSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">12b</span>
                    <span className="header-text">DRIVER AND PEDESTRIAN CONDITION</span>
                  </div>
                </th>
                <th colSpan={5} className="border-right-bold">DRIVERS IN CRASHES</th>
                <th colSpan={5}>PEDESTRIANS IN CRASHES</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3} className="border-right-bold">INJURY</th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th className="border-right-bold">C*</th>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key, index) => {
                const row = this.props.data[key];
                return (
                  <tr key={key} className={key === "TOTAL DRUG INVOLVEMENT" ? "border-bold bold-text" : null}>
                    {index === 0 &&
                      <td rowSpan={Object.keys(this.props.data).length}>
                        <p style={{
                          textAlign: 'center',
                          width: '5px',
                          transform: 'rotate(270deg)',
                          position: 'relative',
                          top: '35px',
                          left: '5px',
                          margin: 0,
                          whiteSpace: 'nowrap'
                        }}>Drug Types</p>
                      </td>
                    }
                    <td className="border-right-bold">{key}</td>
                    <td className="numberTotals">{row.driversTotal}</td>
                    <td className="numberTotals">{row.driversFatal}</td>
                    <td className="numberTotals">{row.driversInjuryA}</td>
                    <td className="numberTotals">{row.driversInjuryB}</td>
                    <td className="numberTotals border-right-bold">{row.driversInjuryC}</td>
                    <td className="numberTotals">{row.pedestriansTotal}</td>
                    <td className="numberTotals">{row.pedestriansFatal}</td>
                    <td className="numberTotals">{row.pedestriansInjuryA}</td>
                    <td className="numberTotals">{row.pedestriansInjuryB}</td>
                    <td className="numberTotals">{row.pedestriansInjuryC}</td>
                  </tr>)
              })}
            </tbody>
          </table>
        </>
        : <p>Loading...</p>
    );
  }
}
